module.exports = __webpack_public_path__ + "img/book.ec783044.svg";